import { useState, type ReactElement } from 'react'
import CustomizableTooltip from '@/components/ui/CustomizableTooltip'
import { CaseSummaryTooltipContent, type CaseSummaryTooltipContentProps } from './CaseSummaryTooltipContent'

/** Shared hover behavior for opinion links and Citation Analysis case lists. */
export function CaseSummaryTooltip({ children, ...content }: Omit<CaseSummaryTooltipContentProps, 'onDismiss'> & { children: ReactElement }) {
  const [open, setOpen] = useState(false)
  return (
    <CustomizableTooltip
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      arrow
      describeChild
      enterDelay={1000}
      enterNextDelay={1000}
      disableTouchListener
      tooltipClassName="!max-w-none !p-5 !bg-white !rounded-md !text-brand-neutral-950 !font-sans border border-brand-neutral-200 shadow-[0_0.6px_25px_0_rgba(0,0,0,0.10),0_10px_10px_0_rgba(0,0,0,0.04)]"
      arrowClassName="!text-white !w-4 !h-2 [&::before]:border [&::before]:border-brand-neutral-200"
      title={<CaseSummaryTooltipContent {...content} onDismiss={() => setOpen(false)} />}
    >
      {children}
    </CustomizableTooltip>
  )
}
